module.exports = __webpack_public_path__ + "static/media/HPUekq5fC90.88ed9b81.jpg";